import SingleApplicantDocumentViewer from './SingleApplicantDocumentViewer';

export default SingleApplicantDocumentViewer;
